import sound from './blast.wav';export default sound;